import { render, staticRenderFns } from "./SwitchProductDialog.vue?vue&type=template&id=76b9cdef"
import script from "./SwitchProductDialog.vue?vue&type=script&lang=js"
export * from "./SwitchProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports